import { render, staticRenderFns } from "./LogoHeader.vue?vue&type=template&id=134b8bfb&"
import script from "./LogoHeader.vue?vue&type=script&lang=js&"
export * from "./LogoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports